import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { User } from '../entities/user';

/**
 * Base url
 */
const BASE_URL = 'users';

/**
 * User service
 */
@Injectable({
  providedIn: 'root',
})
export class UserService {
  /**
   * Is loading
   */
  public loading$: Observable<boolean>;

  /**
   * Constructor
   *
   * @param apiService ApiService
   */
  constructor(private apiService: ApiService) {
    this.loading$ = this.apiService.loading$;
  }

  /**
   * Get
   *
   * @param id Id of user
   */
  get(id: string): Observable<User> {
    return this.apiService.get(`${BASE_URL}/${id}`).pipe(map((user: User) => User.createFromJson(user)));
  }

  /**
   * List
   */
  list(): Observable<User[]> {
    return this.apiService.get(BASE_URL).pipe(map((users) => users.map((user: any) => User.createFromJson(user))));
  }

  /**
   * Create
   *
   * @param user User
   *
   * @returns Observable
   */
  create(user: User): Observable<any> {
    return this.apiService.post(BASE_URL, user);
  }

  /**
   * Delete
   *
   * @param name User name
   *
   * @returns Observable
   */
  delete(name: string): Observable<any> {
    return this.apiService.delete(`${BASE_URL}/${name}`);
  }

  /**
   * Update
   *
   * @param user User
   *
   * @returns Observable
   */
  update(user: User): Observable<any> {
    const username = user.name;
    delete user.name;
    return this.apiService.patch(`${BASE_URL}/${username}`, user);
  }
}
